import React from 'react';

import { FormField, Heading, Label } from '@zillow/constellation';

import type { Section } from '../../../../../models';
import YesAndNo from '../../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  utilityIndividuallyMeteredField: string;
  setSectionValues: (keyValuePairs: object) => void;
  utilityName: string;
};

export default function UtilitiesIndividuallyMetered({
  section,
  setSectionValues,
  utilityName,
  utilityIndividuallyMeteredField,
}: Props): JSX.Element {
  function onNoSeparatelyMetered(): void {
    setSectionValues({
      [utilityIndividuallyMeteredField]: false,
    });
  }

  function onYesSeparatelyMetered(): void {
    setSectionValues({
      [utilityIndividuallyMeteredField]: true,
    });
  }

  return (
    <>
      <Heading level={6} marginBottom="sm">
        {utilityName}
      </Heading>
      <FormField
        label={<Label>{`Is ${utilityName.toLowerCase()} separately metered?`}</Label>}
        control={
          <YesAndNo
            yesHandler={onYesSeparatelyMetered}
            noHandler={onNoSeparatelyMetered}
            yesActive={section.getFieldValue(utilityIndividuallyMeteredField)}
          />
        }
      />
    </>
  );
}
